<template>
  <div class="map-background">
    <div class="login-box">
      <div class="card card-login">
        <div class="card-body">
          <div class="row">
            <div class="col-12 text-center">
              <h2>Set new password</h2>
            </div>
            <div class="col-12">
              <form @submit.prevent="resetPassword">
                <p class="text-center">Use the form below to set your new password.</p>

                <div v-if="hasGlobalErrors" class="alert alert-dismissible alert-danger">
                  <button type="button" class="close" data-dismiss="alert">×</button>
                  {{ errors.token }}
                  {{ errors.nonFieldErrors }}
                  {{ errors.detail }}
                </div>
                <div v-if="successFeedback" class="alert alert-dismissible alert-success">
                  {{ successFeedback }}
                </div>

                <div :class="{ 'form-group': true, 'has-error': errors.newPassword1 }">
                  <div class="input-group">
                    <div class="input-group-addon">
                      <i class="material-icons">lock</i>
                    </div>
                    <input
                      type="password"
                      class="input-lg form-control"
                      name="newPassword1"
                      placeholder="New Password"
                      autocomplete="off"
                      autofocus
                      v-model="newPassword1"
                      :disabled="disabled"
                    />
                  </div>
                  <div class="error-msg">{{ errors.newPassword1 }}</div>
                </div>
                <div :class="{ 'form-group': true, 'has-error': errors.newPassword2 }">
                  <div class="input-group">
                    <div class="input-group-addon">
                      <i class="material-icons">lock</i>
                    </div>
                    <input
                      type="password"
                      class="input-lg form-control"
                      name="newPassword2"
                      placeholder="Repeat Password"
                      autocomplete="off"
                      v-model="newPassword2"
                      :disabled="disabled"
                    />
                  </div>
                  <div class="error-msg">{{ errors.newPassword2 }}</div>
                </div>

                <button
                  type="submit"
                  class="btn btn-raised btn-primary float-right"
                  :disabled="disabled"
                >
                  Set new password
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from '../router'
import formController from '../controllers/form'
import User from '../models/user'

export default {
  extends: formController,
  props: ['uid', 'token'],
  data() {
    return {
      newPassword1: '',
      newPassword2: '',
      successMessage: 'Your password has been reset.'
    }
  },
  methods: {
    resetPassword() {
      this.disabled = true
      User.resetPasswordConfirm(
        this.uid,
        this.token,
        this.newPassword1,
        this.newPassword2
      )
        .done(this.succeed)
        .fail(this.failed)
        .always(this.always)
    },
    succeed(...args) {
      formController.methods.succeed.call(this, ...args)
      this.newPassword1 = ''
      this.newPassword2 = ''
      setTimeout(() => router.push({ path: '/login' }), 3000)
    }
  }
}
</script>
